import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CodeProvider } from './context/CodeContext';
import './index.css'; // Import custom CSS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <CodeProvider>
        <App />
    </CodeProvider>
);